import { clsx } from "@trydig/ui";
import type { PropsWithChildren } from "react";
import styles from "~/features/products/ProductCard/ProductCard.module.css";

export const Description = ({ children }: PropsWithChildren) => (
	<div className={clsx(styles["product-card__desc"])}>{children}</div>
);
